import { RouterModule, Routes } from '@angular/router';

import { BDCPProductDetailsRootComponent } from './pages/root/root.page';
import { NgModule } from '@angular/core';

export const BDCPProductDetailsRoutes: Routes = [
    {
        path: ':sku',
        component: BDCPProductDetailsRootComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(BDCPProductDetailsRoutes)],
    exports: [RouterModule]
})
export class BDCPProductDetailsRoutingModule { }
